import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import BrandForm from './BrandForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditBrandModal extends PureComponent {
    
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }

    submitHandler = ( brand ) => {

        this.setState( { fetching: true } );        
        this.props.updateBrand( brand )
        .then( ( newBrand ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newBrand );
        } );

    }

    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }

    deleteBrand = () => {
        this.setState( { fetching: true } );
        this.props.deleteBrand( this.props.brand.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }

    render() {
        const { brand } = this.props;

        var initialValues = { ...brand };

        return (
            <DLModal title='Edit Brand'
            closeHandler={ this.props.closeModal }>
                <div>
                    <BrandForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {

        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS BRAND?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteBrand }>
                            DELETE BRAND
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }

        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS BRAND
                </span>
            </div>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        updateBrand: ( data ) => {
            return dAPI.patch( `/admin/brands/${ data.id }`, data );
        },
        deleteBrand: ( id ) => {
            return dAPI.delete( `/admin/brands/${ id }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditBrandModal );
